import DOMPurify from 'dompurify';

export const parseString = string => {
  if (string) {
    return string.replaceAll('&#39;', `'`).replaceAll('&#34;', `"`);
  }
  return '';
};

export const isStringContainsHtml = text => {
  return /<\/?[a-z][\s\S]*>/i.test(text);
};

export const capitalizeString = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const stripHtmlTags = string => {
  if (isStringContainsHtml(string)) {
    const sanitizedHtml = DOMPurify.sanitize(string, { USE_PROFILES: { html: true, svg: true }, FORBID_TAGS: ['script'] });
    const doc = new DOMParser().parseFromString(sanitizedHtml, 'text/html');
    return doc.body.textContent;
  }
  return string;
};

export const isEmailFormatValid = email => {
  const re = /([a-zA-Z0-9._-]+([\+]+([a-zA-Z0-9._-])+([a-zA-Z0-9._-])*)*@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]{2,})/gm;
  return re.test(email.toLowerCase());
};

export const clearEmojis = text => {
  const emojiRegex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
  return text.replace(emojiRegex, '');
};

export const clearSpecialSymbols = text => {
  const tagRegex = /[./\\(){}<>[\]?*!@#$%^&*+=~±`"'§;:|\s]/g;
  return text.replace(tagRegex, '');
};

export const toCamelCase = str => {
  return str
    .toLowerCase()
    .replace(/[./\\(){}<>[\]?*!@#$%^&*+=~±`"'§;:|\s&]/g, ' ')
    .split(' ')
    .filter(word => word.length > 0)
    .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join('');
};
